export const ACCOUNT_SETTINGS_FIELD = {
	SEARCH_TRUCK_PICKUP_DATERANGE: 'Search Truck Pickup Date Range:',
	SEARCH_TRUCK_ORIGIN_DEADHEAD_LIMIT: 'Search Truck Origin Deadhead Limit:',
	SEARCH_TRUCK_RESULTS_COUNT: 'Search Truck Results Count:',
	SEARCH_TRUCK_DESTINATION_DEADHEAD_LIMIT: 'Search Truck Destination Deadhead Limit:',
	DEMO_ACCOUNT: 'Demo Account:',
	BCC_USER_OFFERS: 'Bcc User Offers:',
	SEARCHABLE_TRAILER_TYPES: 'Searchable Trailer Types:',
	PICKUP_APPOINTMENT_REQUIRED: 'Pick up Appointment Required:',
	DECLARED_VALUE_REQUIRED: 'Declared Value Required:',
	DELIVERY_APPOINTMENT_REQUIRED: 'Delivery Appointment Required:',
	SEND_RATE_CON: 'Send Rate Con:',
	IS_FEEDBACK_ENABLED: 'Is Feedback Enabled:',
	TRUCK_SEARCH_ENABLED: 'Truck Search Enabled:',
	FREQUENCY_ENABLED: 'Frequency Enabled',
	WEIGHT_REQUIRED: 'Weight Required',
	TARGET_MARGIN: 'Target Margin',
	PROJECT_PROBABILITY: 'Project Probability',
	DEFAULT_TO_MY_PROJECTS: 'Default To My Projects Page',
	ANNUAL_VOLUME: 'Display Annual Volume',
	SCORECARDS: 'Scorecards',
	CUSTOMERS: 'Customers Page',
	CARRIER_RATES: 'Carrier Rates',
	POST_LOAD: 'Post Load',
	VOLUME_REQUIRED: 'Volume Required',
	PROJECTS_BOARD: 'Projects Board',
	USER_ENABLED_PROJECT_BOARD: 'User Enabled Project Board',
	MCLEOD_INTEGRATION: 'Mcleod Integration',
	HAZMAT: 'Hazmat',
	STRONG_LANES: 'Strong Lanes',
	TEAMS_CAPACITY: 'Teams Capacity',
	BOOKING_ASSISTANT: 'Booking Assistant Enabled',
	GET_OPTION_VISIBLE: 'Get Option Visible',
	CUSTOMIZABLE_EMAILS: 'Customizable Emails',
	EMAIL_ROUTING: 'Email Routing',
	CONFIDENCE_SCORE: 'Confidence Score',
	SEND_LOADS_WITH_NO_RATE: 'Send Loads with no Rate',
	RATE_RECENCY_LIMIT: 'Rate Recency Limit',
	PICKUP_DATE_THRESHOLD: 'Pickup Date Threshold',
	PARTIAL_LOAD_ENABLED: 'Partial Load Enabled',
	AMAZON_FREIGHT: 'Amazon Freight',
	ROLE_BASED_CUSTOMER_DATA_ACCESS: 'Role Based Customer Data Access',
	BA_PERFORMANCE_METRICS_ENABLED: 'BA Performance Metrics Enabled',
	PROJECT_GROUPS_ENABLED: 'Waterfall Projects',
	CARRIER_QUALITY: 'Carrier Quality',
	ENABLE_OUT_OF_NETWORK_CARRIERS: 'Out of Network Carriers Enabled',
	CAPACITY_DATA_IN_RFP: 'Capacity Data in RFP'
};
